import { DELETE_POLICY_ADJUSTMENT } from '../../constants/actions/policy';

export function deletePolicyAdjustment(payload) {
    return {
        type: DELETE_POLICY_ADJUSTMENT,
        payload,
    };
}
